export const jobStates = {
  active: {
    title: 'Active',
    slug: 'active',
    path: '/manage-jobs/active',
    value: 'Active',
  },
  pending: {
    title: 'Pending Offer',
    slug: 'pending',
    path: '/manage-jobs/pending',
    value: 'Pending-Offer',
    dateProperty: 'dateLocked',
    dateLabel: 'Offer Date',
    pickupDateLabel: 'Pickup Date',
    pickupDateProperty: 'datePickupExpected',
    deliveryDateLabel: 'Delivery Date',
    deliveryDateProperty: 'dateDeliveryExpected',
  },
  dispatched: {
    title: 'Dispatched',
    slug: 'dispatched',
    path: '/manage-jobs/dispatched',
    value: 'Accepted',
    dateProperty: 'datePickupExpected',
    dateLabel: 'Pickup ETA',
    pickupDateLabel: 'Pickup ETA',
    pickupDateProperty: 'datePickupExpected',
    deliveryDateLabel: 'Delivery ETA',
    deliveryDateProperty: 'dateDeliveryExpected',
  },
  pickedup: {
    title: 'Picked Up',
    slug: 'pickedup',
    path: '/manage-jobs/pickedup',
    value: 'Picked-Up',
    dateProperty: 'dateDeliveryExpected',
    dateLabel: 'Delivery ETA',
    pickupDateLabel: 'Picked Up',
    pickupDateProperty: 'datePickupActual',
    deliveryDateLabel: 'Delivery ETA',
    deliveryDateProperty: 'dateDeliveryExpected',
  },
  delivered: {
    title: 'Delivered',
    slug: 'delivered',
    path: '/manage-jobs/delivered',
    value: 'Delivered',
    dateProperty: 'dateDeliveryActual',
    dateLabel: 'Delivered Date',
    pickupDateLabel: 'Pickup Date',
    pickupDateProperty: 'datePickupActual',
    deliveryDateLabel: 'Delivery Date',
    deliveryDateProperty: 'dateDeliveryActual',
  },
  finalized: {
    title: 'Delivered',
    slug: 'delivered',
    path: '/manage-jobs/delivered',
    value: 'Finalized',
    dateProperty: 'dateDeliveryActual',
    dateLabel: 'Delivered Date',
    pickupDateLabel: 'Pickup Date',
    pickupDateProperty: 'datePickupActual',
    deliveryDateLabel: 'Delivery Date',
    deliveryDateProperty: 'dateDeliveryActual',
  },
};

export const manageRoutes = [
  {
    path: jobStates.pending.path,
    name: jobStates.pending.title,
  },
  {
    path: jobStates.dispatched.path,
    name: jobStates.dispatched.title,
  },
  {
    path: jobStates.pickedup.path,
    name: jobStates.pickedup.title,
  },
  {
    path: jobStates.delivered.path,
    name: jobStates.delivered.title,
  },
];
